import React from 'react';
import {
	ShowButton,
	ReferenceInput,
	DateInput,
	TextInput,
	SelectInput,
	Filter,
	Datagrid,
	TextField,
	DateField,
	FunctionField
} from 'react-admin';
import { AmountField, LinkField } from '../../components/fields';
import TList from '../../components/wrapper/TList';
import {
	coreWalletPaymentTransactionStatusForSelection,
	coreWalletPaymentTransactionTypesForSelection
} from './PaymentTransactionConstants';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import PaymentTransactionListActions from './PaymentTransactionListActions';

const PaymentTransactionFilter = props => (
	<Filter {...props}>
		<SelectInput
			alwaysOn
			resettable
			source="paymentTransactionType"
			choices={coreWalletPaymentTransactionTypesForSelection}
		/>
		<SelectInput
			alwaysOn
			resettable
			source="paymentTransactionStatus"
			choices={coreWalletPaymentTransactionStatusForSelection}
		/>
		<ReferenceInput source="currency" reference="currencies">
			<SelectInput optionText="name" resettable />
		</ReferenceInput>
		<TextInput alwaysOn resettable source="referenceTransactionId" />
		<TextInput resettable source="paymentInstrumentPublicId" />
		<TextInput resettable source="businessContractId" />
		<TextInput resettable source="paymentGatewayIdentifier" />
		<TextInput resettable source="paymentGatewayVersion" />
		<TextInput resettable source="ownerType" />
		<TextInput resettable source="ownerId" />
		<DateInput
			source="fromDate"
			label="resources.accountingAccountTransfers.filter.fromDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<DateInput
			source="untilDate"
			label="resources.accountingAccountTransfers.filter.untilDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
	</Filter>
);

const PaymentTransactionList = props => (
	<TList
		{...props}
		filters={<PaymentTransactionFilter />}
		actions={<PaymentTransactionListActions />}
		sort={{ field: 'id', order: 'DESC' }}
	>
		<Datagrid >
			<ShowButton />
			<TextField source="id" />
			<DateField source="creationDateTime" showTime />
			<AmountField source="amount" sortable={false} />
			<TextField source="type" sortable={false} />
			<TextField source="status" sortable={false} />
			<TextField source="paymentInstrumentPublicId" sortable={false} />
			<FunctionField
				label="resources.paymentTransactions.fields.paymentGatewayIdentifier"
				sortable={false}
				render={({ gatewayIdentifier }) => {
					return gatewayIdentifier !== undefined && gatewayIdentifier !== null ? `${gatewayIdentifier.name} ${gatewayIdentifier.version}` : '';
				}}
			/>
			<LinkField source="owner" sortable={false} />
		</Datagrid>
	</TList>
);

export default PaymentTransactionList;
